import { buildAxiosInstance, buildAxiosWithoutInterceptors, buildMakeUseAxios } from "@api";

export const axios = buildMakeUseAxios(`${import.meta.env.VITE_CANDIDATE_SERVICE_URL}`);
export const axiosV2 = buildMakeUseAxios(`${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/v2`);
export const axiosCandidateInstance = buildAxiosInstance(`${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/candidates`);
export const axiosCandidateInstanceV2 = buildAxiosInstance(
  `${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/v2/candidates`
);
export const axiosWithoutInterceptors = buildAxiosWithoutInterceptors(
  `${import.meta.env.VITE_CANDIDATE_SERVICE_URL}/v2/candidates`
);
